module.exports = __webpack_public_path__ + "static/media/profile.056db542.jpg";